<template>
    <div>
        <v-container pa-3>
            <h2>Tarkpay usage</h2>

            <p class="pt-4">There are three methods of using Tarkpay:</p>
            <ul>
                <li>User can be redirected to Tarkpay.com payment landing page.</li>
                <li>PIS links can be downloaded and sent to be used or displayed in your solution.</li>
                <li>PIS links can be added to your solution via a modal window.</li>
            </ul>

            <h3 class="mt-4">Method 1: Tarkpay landing page</h3>
            <p>
                User will be redirected from your website to an unique tarkpay.com page (generated for this spesific
                payment), information about the payment is displayed and user has the option to choose the bank from
                where the payment is initiated. This is the easiest solution to integrate since user will communicate
                via tarkpay.com.
            </p>
            <p>
                The solution can be tested right here in this environment:
            </p>
            <ol>
                <li>Click on <a href="/admin/payment/create">Create payment</a>.</li>
                <li>Enter payment sum and description, and click "Create".</li>
                <li>Then you can see links, click on the bottom one and choose a payment method</li>
                <li>
                    The most simple way is to use either LHV or COOP for testing as it does not require one to create an
                    account in their Sandbox environment. In LHV, you can select "Choose user" to log in and in Coop you
                    can use "obcoop1" for username and password to log in.
                </li>
            </ol>
            <h3 class="mt-4">Method 2: Tarkpay banklinks</h3>
            <p>
                User is shown diferent bank logos on your website, after choosing the bank that the user wants to make
                the payment from, user is sent to chosen bank to confirm the payment. The generated links can be added
                into an e-mail (user will be redirected from the e-mail to the chosen bank). Some banks will let the
                user choose between accounts (if the user has multiple accounts), for this the user will be redirected
                to tarkpay.com page
            </p>

            <h3 class="mt-4">Method 3: Modal window on your website</h3>
            <p>
                User will remain on your website, modal will be embedded into it. Some banks let the transaction to be
                confirmed with decoupled approach, meaning the person making the payment will not leave your website. It
                takes nothing else than to create payment via API and embed a simple piece of Javascript on your
                website.
            </p>
            <p>
                It is possible to embed Tarkpay's modal window on your website. It takes nothing else than to create
                payment via API and embed a simple piece of Javascript on your website.<br />To see it in action, click
                <a id="createrPaymentDemo" @click="createPaymentAndShowModalDemo()" href="javascript: {}">here</a>
            </p>
            <a id="show-payment-modal" style="display:none;"></a>

            <v-divider class="mb-3 mt-5"></v-divider>
            <h2>Using the API</h2>
            <p class="pt-4">
                API Documentation can be found here:
                <a href=" https://documenter.getpostman.com/view/7175536/TVCfX91i"
                    >https://documenter.getpostman.com/view/7175536/TVCfX91i</a
                >
            </p>

            <p>
                The API URLs are:
            </p>
            <ul>
                <li>Testing environemnt: https://sandbox.tarkpay.com/api/v2</li>
                <li>LIVE environemnt: https://tarkpay.com/api/v2</li>
            </ul>
            <p style="font-size: small; font-style: italic;">
                There is also v1 version of API, but there is not banks country based data. We recommend you to use v2
                version of our API.
            </p>
            <p class="pt-1">
                You can get your API access, by creating an API key and client ID for the company via settings. This can
                be done by going into your company’s settings, clicking edit, choosing „Integration info“ tab and
                clicking Generate for API key and Client ID. Write down the API key, as this will not be shown later.
                API key is used making requests from server to server, this is your secret key and should be kept
                secret. This can be regenerated again, if lost.<br />
                Client ID is used, when using the modal method for payments, this is what can be considered as public
                key.
            </p>
            <p>
                Tarkpay landingpage flow is simple to implement. You just need to send an API request with your API key
                and payment details to POST /api/v2/payment - described in the API documentation.<br />
                You will get a link as response. Simply redirect the user to this link and the user can start payment on
                Tarkpay's payment landing page.
            </p>
            <p>
                For embedded flow you have to include Tarkpays Javascript in the page.<br />
                For Sandbox the Javascript URL is: https://sandbox.tarkpay.com/static/dist/embed/js/tp-embed.js<br />
                For Production the Javascript URL is: https://tarkpay.com/static/dist/embed/js/tp-embed.js
            </p>
            <p>
                After including the scripts you can initiate Tarkpays payment solution with the follwoing script
                <code>
                    <br />
                    window.TarkPay.initialize({<br />
                    btn_id: "show-payment-modal",<br />
                    redirect: true,<br />
                    client_id: "",<br />
                    locale: "et_EE",<br />
                    is_modal: true,<br />
                    payment_id: response.data.payment.payment_token,<br />
                    onClose: () => {<br />
                    <br />
                    }<br />
                    });<br />
                </code>
            </p>

            <ul>
                <li>btn_id - the button where the user has to click to open the payment modal</li>
                <li>
                    redirect - currently the value has to be true. Later can be used false when decoupled flow is
                    enabled
                </li>
                <li>client_id - the client ID you got under company settings</li>
                <li>locale - the default locale and language for the modal window, available values et_EE, en_GB</li>
                <li>
                    is_modal - if true, used as modal, if false, then the contents will be included in a specified
                    container on page. Use container_id parameter in script initiation settings
                </li>
                <li>payment_id - the payment id you received via call to POST /api/v1/payment</li>
                <li>onClose - callback when user closes the modal</li>
            </ul>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import settings from "../../settings";
export default {
    name: "landing-page",
    mounted() {
        let demo_payment_key = window.localStorage.getItem("demo-payment-key");
        let demo_payment_client_id = window.localStorage.getItem("demo-payment-client-id");
        if (demo_payment_key) {
            window.TarkPay.initialize({
                btn_id: "show-payment-modal",
                redirect: true,
                client_id: demo_payment_client_id,
                locale: "et_EE",
                is_modal: true,
                payment_id: demo_payment_key,
                onClose: () => {
                    window.localStorage.removeItem("demo-payment-key");
                    window.localStorage.removeItem("demo-payment-client-id");
                }
            });
        }
    },
    methods: {
        async createPaymentAndShowModalDemo() {
            let response = await axios.post(settings.api_url + "/api/v2/create-demo-payment");
            if (response.data.payment) {
                window.localStorage.setItem("demo-payment-key", response.data.payment.payment_token);
                window.localStorage.setItem("demo-payment-client-id", response.data.payment.client_id);
                window.TarkPay.initialize({
                    btn_id: "show-payment-modal",
                    redirect: true,
                    client_id: response.data.payment.client_id,
                    locale: "et_EE",
                    is_modal: true,
                    payment_id: response.data.payment.payment_token,
                    onClose: () => {
                        window.localStorage.removeItem("demo-payment-key");
                        window.localStorage.removeItem("demo-payment-client-id");
                    }
                });
                setTimeout(() => {
                    document.getElementById("show-payment-modal").click();
                }, 600);
            } else {
                alert("Something went wrong :/");
            }
        }
    }
};
</script>

<style scoped></style>
